export var getCookie = function (key) {
    var cookieString = document.cookie;
    var cookies = cookieString.split('; ');
    for (var _i = 0, cookies_1 = cookies; _i < cookies_1.length; _i++) {
        var cookie = cookies_1[_i];
        var _a = cookie.split('='), cookieName = _a[0], value = _a[1];
        if (cookieName === key) {
            return decodeURIComponent(value);
        }
    }
    return null;
};
export var deleteCookie = function (key) {
    document.cookie = "".concat(key, "=; max-age=0; path=/");
};
